import { z } from "zod";

export const AiIdentificationId_Schema = z.uuid();
